// Textos de Proyectos, Mis inversiones y Mis ofertas: { es: {...}, en: {...}, pt: {...} }
export default {
  es: {
    'mercado.hoy': 'Hoy',
    'mercado.dia': '1 día',
    'mercado.dias': '{n} días',
    'mercado.plazoCualquiera': 'Cualquier plazo',
    'mercado.plazo30': 'Hasta 30 días',
    'mercado.plazo90': 'Hasta 3 meses',
    'mercado.plazo365': 'Hasta 1 año',
    'mercado.ordDestacados': 'Destacados',
    'mercado.ordAvance': 'Mayor avance',
    'mercado.ordTasa': 'Mayor tasa',
    'mercado.ordVence': 'Vencen primero',
    'mercado.ordMonto': 'Menor monto',
    'mercado.errorCarga': 'No pudimos cargar los proyectos. Revisa tu conexión e intenta de nuevo.',
    'mercado.titulo': 'Proyectos',
    'mercado.sub': 'Elige dónde invertir. Todo se paga desde tu wallet en USDT.',
    'mercado.ariaMercado': 'Mercado',
    'mercado.primario': 'Mercado primario',
    'mercado.secundario': 'Mercado secundario',
    'mercado.explicaSec': 'Compra participaciones que otros inversionistas ponen a la venta, a su precio de oferta.',
    'mercado.explicaPri': 'Invierte directamente en proyectos nuevos y sigue su avance hasta el vencimiento.',
    'mercado.filtros': 'Filtros',
    'mercado.buscarPh': 'Buscar por nombre, contrato, categoría o emisor',
    'mercado.buscarAria': 'Buscar proyectos',
    'mercado.categoria': 'Categoría',
    'mercado.todasCat': 'Todas las categorías',
    'mercado.pais': 'País',
    'mercado.todosPaises': 'Todos los países',
    'mercado.riesgo': 'Riesgo',
    'mercado.todoRiesgo': 'Todo riesgo',
    'mercado.plazo': 'Plazo',
    'mercado.ordenar': 'Ordenar por',
    'mercado.cargando': 'Cargando…',
    'mercado.nProyecto': '{n} proyecto',
    'mercado.nProyectos': '{n} proyectos',
    'mercado.quitarFiltro': 'Quitar {n} filtro',
    'mercado.quitarFiltros': 'Quitar {n} filtros',
    'mercado.vista': 'Vista',
    'mercado.tarjetas': 'Tarjetas',
    'mercado.tabla': 'Tabla',
    'mercado.reintentar': 'Reintentar',
    'mercado.sinSecundario': 'Aún no hay participaciones a la venta.',
    'mercado.sinPrimario': 'Por ahora no hay proyectos abiertos.',
    'mercado.sinCoincidencia': 'Ningún proyecto coincide con tu búsqueda.',
    'mercado.quitarFiltrosBtn': 'Quitar filtros',
    'mercado.proyecto': 'Proyecto',
    'mercado.tasa': 'Tasa',
    'mercado.venceEn': 'Vence en',
    'mercado.precio': 'Precio',
    'mercado.avance': 'Avance',
    'mercado.comprar': 'Comprar',
    'mercado.invertir': 'Invertir',
    'mercado.precioVenta': 'Precio de venta',
    'mercado.valorOriginal': 'Valor original {monto}',
    'mercado.financiado': 'financiado',
    'mercado.disponibles': '{monto} disponibles',
    'mercado.garantia': 'Garantía',
    'mercado.verComprar': 'Ver y comprar',
    'mercado.verInvertir': 'Ver e invertir',
    'panel.cerrar': 'Cerrar',
    'panel.contrato': 'Contrato {n}',
    'panel.distribucion': 'Distribución del contrato',
    'panel.ariaFinanciado': '{pct}% financiado',
    'panel.invertido': 'Invertido',
    'panel.disponible': 'Disponible',
    'panel.participantes': 'Participantes',
    'panel.parcelas': '{n} parcelas del mismo contrato',
    'panel.tasa': 'Tasa',
    'panel.vence': 'Vence',
    'panel.plazoRestante': 'Plazo restante',
    'panel.riesgo': 'Riesgo',
    'panel.garantia': 'Garantía',
    'panel.docsAria': 'Documentos del proyecto',
    'panel.docs': 'Documentos',
    'panel.listo': '¡Listo!',
    'panel.precioCompra': 'Precio de compra',
    'panel.cuanto': '¿Cuánto quieres invertir? (USDT)',
    'panel.recibirias': 'Recibirías al vencimiento',
    'panel.disponibleWallet': 'Disponible en tu wallet',
    'panel.procesando': 'Procesando…',
    'panel.confirmarCompra': 'Confirmar compra',
    'panel.confirmarInversion': 'Confirmar inversión',
    'panel.aviso': 'El rendimiento es estimado y depende del cumplimiento del proyecto.',
    'panel.errMinimo': 'El monto mínimo es {min} USDT.',
    'panel.errRestante': 'Solo quedan {monto} USDT disponibles en este proyecto.',
    'panel.errSaldo': 'No tienes saldo suficiente en tu wallet. Haz un depósito para continuar.',
    'panel.exitoDef': 'Operación realizada.',
    'panel.errorDef': 'No se pudo completar la operación. Intenta de nuevo.',
    'inv.ref': 'Inversión #{id}',
    'inv.vendida': 'Vendida',
    'inv.enVenta': 'En venta',
    'inv.invertidos': 'invertidos',
    'inv.venceHoy': 'Vence hoy',
    'inv.paraCierre1': '1 día para el cierre',
    'inv.paraCierre': '{n} días para el cierre',
    'inv.tasa': 'Tasa',
    'inv.vendidaPor': 'Vendida por',
    'inv.saldoTotal': 'Saldo total',
    'inv.fechaVenta': 'Fecha de venta',
    'inv.cierre': 'Cierre',
    'inv.yaEnVenta': 'Ya está en venta',
    'inv.ponerVenta': 'Poner en venta',
    'inv.titulo': 'Mis inversiones',
    'inv.sub': 'Lo que has puesto a trabajar y cuánto va ganando.',
    'inv.kpiInvertido': 'Invertido',
    'inv.kpiRend': 'Rendimiento acumulado',
    'inv.kpiSaldo': 'Saldo total',
    'inv.kpiActivas': 'Inversiones activas',
    'inv.tabActivas': 'Activas',
    'inv.tabVendidas': 'Vendidas',
    'inv.verProyectos': 'Ver proyectos',
    'inv.vacioActivas': 'Aún no tienes inversiones activas',
    'inv.vacioVendidas': 'Aún no has vendido inversiones',
    'inv.vacioActivasAyuda': 'Elige un proyecto y empieza desde 50 USDT.',
    'inv.vacioVendidasAyuda': 'Cuando vendas una inversión en el mercado secundario aparecerá aquí.',
    'inv.explorar': 'Explorar proyectos',
    'inv.fHoy': 'Hoy',
    'inv.fElegir': 'Elegir fecha',
    'inv.fSin': 'Sin vencimiento',
    'inv.modalAria': 'Poner inversión en venta',
    'inv.rendimiento': 'Rendimiento',
    'inv.invertisteEl': 'Invertiste el',
    'inv.cierraEl': 'Cierra el',
    'inv.queParte': '¿Qué parte quieres vender?',
    'inv.hastaCuando': '¿Hasta cuándo estará en venta?',
    'inv.vigencia': 'Vigencia de la oferta',
    'inv.fechaLimite': 'Fecha límite',
    'inv.recibiras': 'Recibirás al venderse',
    'inv.cancelar': 'Cancelar',
    'inv.publicando': 'Publicando…',
    'inv.publicar': 'Publicar oferta',
    'ofertas.confirmarCancelar': '¿Cancelar la oferta de {name}? Volverá a tus inversiones activas.',
    'ofertas.canceladaDef': 'Oferta cancelada.',
    'ofertas.errorCancelar': 'No se pudo cancelar la oferta.',
    'ofertas.titulo': 'Mis ofertas',
    'ofertas.sub': 'Inversiones que pusiste en venta en el mercado secundario.',
    'ofertas.kpiPublicadas': 'Ofertas publicadas',
    'ofertas.kpiValor': 'Valor en venta',
    'ofertas.tabOfertas': 'Mis ofertas',
    'ofertas.tabProyectos': 'Mis proyectos',
    'ofertas.vacio': 'No tienes ofertas publicadas',
    'ofertas.vacioAyuda': 'Desde Mis inversiones puedes poner en venta la parte que quieras.',
    'ofertas.irInversiones': 'Ir a mis inversiones',
    'ofertas.ref': 'Oferta #{id}',
    'ofertas.enVenta': 'En venta',
    'ofertas.precioVenta': 'precio de venta',
    'ofertas.montoOfertado': 'Monto ofertado',
    'ofertas.rendimiento': 'Rendimiento',
    'ofertas.saldo': 'Saldo',
    'ofertas.publicada': 'Publicada',
    'ofertas.vence': 'Vence',
    'ofertas.cancelando': 'Cancelando…',
    'ofertas.cancelar': 'Cancelar oferta',
    'ofertas.listado': 'Listado de ofertas',
    'ofertas.filtroProyecto': ' - - -  Nombre del Proyecto - - - ',
    'ofertas.filtroVenc': ' - - - Periodo de Vencimiento - - -',
    'ofertas.v1': 'Hoy',
    'ofertas.v2': ' Próximos 7 días',
    'ofertas.v3': ' Próximos 30 días',
    'ofertas.v4': 'Próximos 360 días',
    'ofertas.sinProyectosTitulo': '¡Ups, sin proyectos ofertados!',
    'ofertas.sinProyectosD': 'Todavía no tiene sus propios proyectos ofertados en Panther7',
    'ofertas.sinProyectosM': 'Todavia no tiene sus propios proyectos ofertados en Panther7',
    'ofertas.suenosD': '¿Sabias que sus sueños se pueden cumplir, ofertando sus propios proyectos en Panther7? ',
    'ofertas.suenosM': '¿Sabias que sus sueños se pueden cumplir, ofertando tus propios proyectos en Panther7? ',
    'ofertas.oficinasD': 'Para colocar proyectos propios en Panther7, Diríjase directamente a las oficinas consultoras sede en su zona país ',
    'ofertas.oficinasM': '¡Para colocar proyectos propios en Panther7, Diríjase directamente a las oficinas consultoras sede en su zona país! ',
    'ofertas.aceptar': 'Aceptar',
    'srv:Inversión efectuada correctamente': 'Inversión efectuada correctamente',
    'srv:Compra Efectuada correctamente': 'Compra Efectuada correctamente',
    'srv:Oferta Efectuada correctamente': 'Oferta Efectuada correctamente',
    'srv:Oferta Cancelada correctamente': 'Oferta Cancelada correctamente',
    'srv:Cliente no posee saldo suficiente.': 'Cliente no posee saldo suficiente.',
    'srv:CLIENTE NO POSEE SALDO SUFICIENTE': 'CLIENTE NO POSEE SALDO SUFICIENTE',
    'srv: Cantidad excede el disponible para el proyecto': ' Cantidad excede el disponible para el proyecto',
    'srv:Cantidad excede el disponible para el proyecto': 'Cantidad excede el disponible para el proyecto',
    'srv:Oferta no disponible para la venta': 'Oferta no disponible para la venta',
    'srv:La inversion no esta disponible para la venta': 'La inversion no esta disponible para la venta',
    'srv:Participación no puede ser vendida. No pertenece al cliente o no esta activa': 'Participación no puede ser vendida. No pertenece al cliente o no esta activa',
    'srv:Oferta no activa o no pertenece al cliente': 'Oferta no activa o no pertenece al cliente',
    'srv:Error al procesar la venta': 'Error al procesar la venta',
  },
  en: {
    'mercado.hoy': 'Today',
    'mercado.dia': '1 day',
    'mercado.dias': '{n} days',
    'mercado.plazoCualquiera': 'Any term',
    'mercado.plazo30': 'Up to 30 days',
    'mercado.plazo90': 'Up to 3 months',
    'mercado.plazo365': 'Up to 1 year',
    'mercado.ordDestacados': 'Featured',
    'mercado.ordAvance': 'Most funded',
    'mercado.ordTasa': 'Highest rate',
    'mercado.ordVence': 'Maturing first',
    'mercado.ordMonto': 'Lowest amount',
    'mercado.errorCarga': 'We could not load the projects. Check your connection and try again.',
    'mercado.titulo': 'Projects',
    'mercado.sub': 'Choose where to invest. Everything is paid from your wallet in USDT.',
    'mercado.ariaMercado': 'Market',
    'mercado.primario': 'Primary market',
    'mercado.secundario': 'Secondary market',
    'mercado.explicaSec': 'Buy stakes that other investors put up for sale, at their offer price.',
    'mercado.explicaPri': 'Invest directly in new projects and follow their progress until maturity.',
    'mercado.filtros': 'Filters',
    'mercado.buscarPh': 'Search by name, contract, category or issuer',
    'mercado.buscarAria': 'Search projects',
    'mercado.categoria': 'Category',
    'mercado.todasCat': 'All categories',
    'mercado.pais': 'Country',
    'mercado.todosPaises': 'All countries',
    'mercado.riesgo': 'Risk',
    'mercado.todoRiesgo': 'Any risk',
    'mercado.plazo': 'Term',
    'mercado.ordenar': 'Sort by',
    'mercado.cargando': 'Loading…',
    'mercado.nProyecto': '{n} project',
    'mercado.nProyectos': '{n} projects',
    'mercado.quitarFiltro': 'Remove {n} filter',
    'mercado.quitarFiltros': 'Remove {n} filters',
    'mercado.vista': 'View',
    'mercado.tarjetas': 'Cards',
    'mercado.tabla': 'Table',
    'mercado.reintentar': 'Retry',
    'mercado.sinSecundario': 'There are no stakes for sale yet.',
    'mercado.sinPrimario': 'There are no open projects right now.',
    'mercado.sinCoincidencia': 'No project matches your search.',
    'mercado.quitarFiltrosBtn': 'Clear filters',
    'mercado.proyecto': 'Project',
    'mercado.tasa': 'Rate',
    'mercado.venceEn': 'Matures in',
    'mercado.precio': 'Price',
    'mercado.avance': 'Progress',
    'mercado.comprar': 'Buy',
    'mercado.invertir': 'Invest',
    'mercado.precioVenta': 'Sale price',
    'mercado.valorOriginal': 'Original value {monto}',
    'mercado.financiado': 'funded',
    'mercado.disponibles': '{monto} available',
    'mercado.garantia': 'Guarantee',
    'mercado.verComprar': 'View and buy',
    'mercado.verInvertir': 'View and invest',
    'panel.cerrar': 'Close',
    'panel.contrato': 'Contract {n}',
    'panel.distribucion': 'Contract breakdown',
    'panel.ariaFinanciado': '{pct}% funded',
    'panel.invertido': 'Invested',
    'panel.disponible': 'Available',
    'panel.participantes': 'Participants',
    'panel.parcelas': '{n} parcels of the same contract',
    'panel.tasa': 'Rate',
    'panel.vence': 'Matures',
    'panel.plazoRestante': 'Remaining term',
    'panel.riesgo': 'Risk',
    'panel.garantia': 'Guarantee',
    'panel.docsAria': 'Project documents',
    'panel.docs': 'Documents',
    'panel.listo': 'Done!',
    'panel.precioCompra': 'Purchase price',
    'panel.cuanto': 'How much do you want to invest? (USDT)',
    'panel.recibirias': 'You would receive at maturity',
    'panel.disponibleWallet': 'Available in your wallet',
    'panel.procesando': 'Processing…',
    'panel.confirmarCompra': 'Confirm purchase',
    'panel.confirmarInversion': 'Confirm investment',
    'panel.aviso': 'The return is an estimate and depends on the project meeting its obligations.',
    'panel.errMinimo': 'The minimum amount is {min} USDT.',
    'panel.errRestante': 'Only {monto} USDT remain available in this project.',
    'panel.errSaldo': 'You do not have enough balance in your wallet. Make a deposit to continue.',
    'panel.exitoDef': 'Operation completed.',
    'panel.errorDef': 'The operation could not be completed. Please try again.',
    'inv.ref': 'Investment #{id}',
    'inv.vendida': 'Sold',
    'inv.enVenta': 'For sale',
    'inv.invertidos': 'invested',
    'inv.venceHoy': 'Matures today',
    'inv.paraCierre1': '1 day until closing',
    'inv.paraCierre': '{n} days until closing',
    'inv.tasa': 'Rate',
    'inv.vendidaPor': 'Sold for',
    'inv.saldoTotal': 'Total balance',
    'inv.fechaVenta': 'Sale date',
    'inv.cierre': 'Closing',
    'inv.yaEnVenta': 'Already for sale',
    'inv.ponerVenta': 'Put up for sale',
    'inv.titulo': 'My investments',
    'inv.sub': 'What you have put to work and how much it is earning.',
    'inv.kpiInvertido': 'Invested',
    'inv.kpiRend': 'Accumulated return',
    'inv.kpiSaldo': 'Total balance',
    'inv.kpiActivas': 'Active investments',
    'inv.tabActivas': 'Active',
    'inv.tabVendidas': 'Sold',
    'inv.verProyectos': 'View projects',
    'inv.vacioActivas': 'You have no active investments yet',
    'inv.vacioVendidas': 'You have not sold any investments yet',
    'inv.vacioActivasAyuda': 'Choose a project and start from USDT 50.',
    'inv.vacioVendidasAyuda': 'When you sell an investment on the secondary market it will appear here.',
    'inv.explorar': 'Explore projects',
    'inv.fHoy': 'Today',
    'inv.fElegir': 'Pick a date',
    'inv.fSin': 'No expiry',
    'inv.modalAria': 'Put investment up for sale',
    'inv.rendimiento': 'Return',
    'inv.invertisteEl': 'You invested on',
    'inv.cierraEl': 'Closes on',
    'inv.queParte': 'What portion do you want to sell?',
    'inv.hastaCuando': 'Until when will it be for sale?',
    'inv.vigencia': 'Offer validity',
    'inv.fechaLimite': 'Deadline',
    'inv.recibiras': 'You will receive when it sells',
    'inv.cancelar': 'Cancel',
    'inv.publicando': 'Publishing…',
    'inv.publicar': 'Publish offer',
    'ofertas.confirmarCancelar': 'Cancel the offer for {name}? It will go back to your active investments.',
    'ofertas.canceladaDef': 'Offer cancelled.',
    'ofertas.errorCancelar': 'The offer could not be cancelled.',
    'ofertas.titulo': 'My offers',
    'ofertas.sub': 'Investments you put up for sale on the secondary market.',
    'ofertas.kpiPublicadas': 'Published offers',
    'ofertas.kpiValor': 'Value for sale',
    'ofertas.tabOfertas': 'My offers',
    'ofertas.tabProyectos': 'My projects',
    'ofertas.vacio': 'You have no published offers',
    'ofertas.vacioAyuda': 'From My investments you can put up for sale any portion you want.',
    'ofertas.irInversiones': 'Go to my investments',
    'ofertas.ref': 'Offer #{id}',
    'ofertas.enVenta': 'For sale',
    'ofertas.precioVenta': 'sale price',
    'ofertas.montoOfertado': 'Offered amount',
    'ofertas.rendimiento': 'Return',
    'ofertas.saldo': 'Balance',
    'ofertas.publicada': 'Published',
    'ofertas.vence': 'Matures',
    'ofertas.cancelando': 'Cancelling…',
    'ofertas.cancelar': 'Cancel offer',
    'ofertas.listado': 'Offers list',
    'ofertas.filtroProyecto': ' - - -  Project name - - - ',
    'ofertas.filtroVenc': ' - - - Maturity period - - -',
    'ofertas.v1': 'Today',
    'ofertas.v2': ' Next 7 days',
    'ofertas.v3': ' Next 30 days',
    'ofertas.v4': 'Next 360 days',
    'ofertas.sinProyectosTitulo': 'Oops, no offered projects!',
    'ofertas.sinProyectosD': 'You do not have any of your own projects offered on Panther7 yet',
    'ofertas.sinProyectosM': 'You do not have any of your own projects offered on Panther7 yet',
    'ofertas.suenosD': 'Did you know your dreams can come true by offering your own projects on Panther7? ',
    'ofertas.suenosM': 'Did you know your dreams can come true by offering your own projects on Panther7? ',
    'ofertas.oficinasD': 'To list your own projects on Panther7, go directly to the consulting head offices in your country area ',
    'ofertas.oficinasM': 'To list your own projects on Panther7, go directly to the consulting head offices in your country area! ',
    'ofertas.aceptar': 'OK',
    'srv:Inversión efectuada correctamente': 'Investment completed successfully',
    'srv:Compra Efectuada correctamente': 'Purchase completed successfully',
    'srv:Oferta Efectuada correctamente': 'Offer published successfully',
    'srv:Oferta Cancelada correctamente': 'Offer cancelled successfully',
    'srv:Cliente no posee saldo suficiente.': 'Insufficient balance.',
    'srv:CLIENTE NO POSEE SALDO SUFICIENTE': 'INSUFFICIENT BALANCE',
    'srv: Cantidad excede el disponible para el proyecto': ' Amount exceeds what is available for the project',
    'srv:Cantidad excede el disponible para el proyecto': 'Amount exceeds what is available for the project',
    'srv:Oferta no disponible para la venta': 'Offer not available for sale',
    'srv:La inversion no esta disponible para la venta': 'The investment is not available for sale',
    'srv:Participación no puede ser vendida. No pertenece al cliente o no esta activa': 'This stake cannot be sold. It does not belong to the client or is not active',
    'srv:Oferta no activa o no pertenece al cliente': 'Offer is not active or does not belong to the client',
    'srv:Error al procesar la venta': 'Error processing the sale',
  },
  pt: {
    'mercado.hoy': 'Hoje',
    'mercado.dia': '1 dia',
    'mercado.dias': '{n} dias',
    'mercado.plazoCualquiera': 'Qualquer prazo',
    'mercado.plazo30': 'Até 30 dias',
    'mercado.plazo90': 'Até 3 meses',
    'mercado.plazo365': 'Até 1 ano',
    'mercado.ordDestacados': 'Destaques',
    'mercado.ordAvance': 'Maior progresso',
    'mercado.ordTasa': 'Maior taxa',
    'mercado.ordVence': 'Vencem primeiro',
    'mercado.ordMonto': 'Menor valor',
    'mercado.errorCarga': 'Não foi possível carregar os projetos. Verifique sua conexão e tente novamente.',
    'mercado.titulo': 'Projetos',
    'mercado.sub': 'Escolha onde investir. Tudo é pago da sua carteira em USDT.',
    'mercado.ariaMercado': 'Mercado',
    'mercado.primario': 'Mercado primário',
    'mercado.secundario': 'Mercado secundário',
    'mercado.explicaSec': 'Compre participações que outros investidores colocam à venda, pelo preço da oferta.',
    'mercado.explicaPri': 'Invista diretamente em projetos novos e acompanhe o progresso até o vencimento.',
    'mercado.filtros': 'Filtros',
    'mercado.buscarPh': 'Buscar por nome, contrato, categoria ou emissor',
    'mercado.buscarAria': 'Buscar projetos',
    'mercado.categoria': 'Categoria',
    'mercado.todasCat': 'Todas as categorias',
    'mercado.pais': 'País',
    'mercado.todosPaises': 'Todos os países',
    'mercado.riesgo': 'Risco',
    'mercado.todoRiesgo': 'Qualquer risco',
    'mercado.plazo': 'Prazo',
    'mercado.ordenar': 'Ordenar por',
    'mercado.cargando': 'Carregando…',
    'mercado.nProyecto': '{n} projeto',
    'mercado.nProyectos': '{n} projetos',
    'mercado.quitarFiltro': 'Remover {n} filtro',
    'mercado.quitarFiltros': 'Remover {n} filtros',
    'mercado.vista': 'Visualização',
    'mercado.tarjetas': 'Cartões',
    'mercado.tabla': 'Tabela',
    'mercado.reintentar': 'Tentar novamente',
    'mercado.sinSecundario': 'Ainda não há participações à venda.',
    'mercado.sinPrimario': 'No momento não há projetos abertos.',
    'mercado.sinCoincidencia': 'Nenhum projeto corresponde à sua busca.',
    'mercado.quitarFiltrosBtn': 'Limpar filtros',
    'mercado.proyecto': 'Projeto',
    'mercado.tasa': 'Taxa',
    'mercado.venceEn': 'Vence em',
    'mercado.precio': 'Preço',
    'mercado.avance': 'Progresso',
    'mercado.comprar': 'Comprar',
    'mercado.invertir': 'Investir',
    'mercado.precioVenta': 'Preço de venda',
    'mercado.valorOriginal': 'Valor original {monto}',
    'mercado.financiado': 'financiado',
    'mercado.disponibles': '{monto} disponíveis',
    'mercado.garantia': 'Garantia',
    'mercado.verComprar': 'Ver e comprar',
    'mercado.verInvertir': 'Ver e investir',
    'panel.cerrar': 'Fechar',
    'panel.contrato': 'Contrato {n}',
    'panel.distribucion': 'Distribuição do contrato',
    'panel.ariaFinanciado': '{pct}% financiado',
    'panel.invertido': 'Investido',
    'panel.disponible': 'Disponível',
    'panel.participantes': 'Participantes',
    'panel.parcelas': '{n} parcelas do mesmo contrato',
    'panel.tasa': 'Taxa',
    'panel.vence': 'Vence',
    'panel.plazoRestante': 'Prazo restante',
    'panel.riesgo': 'Risco',
    'panel.garantia': 'Garantia',
    'panel.docsAria': 'Documentos do projeto',
    'panel.docs': 'Documentos',
    'panel.listo': 'Pronto!',
    'panel.precioCompra': 'Preço de compra',
    'panel.cuanto': 'Quanto você quer investir? (USDT)',
    'panel.recibirias': 'Você receberia no vencimento',
    'panel.disponibleWallet': 'Disponível na sua carteira',
    'panel.procesando': 'Processando…',
    'panel.confirmarCompra': 'Confirmar compra',
    'panel.confirmarInversion': 'Confirmar investimento',
    'panel.aviso': 'O rendimento é estimado e depende do cumprimento do projeto.',
    'panel.errMinimo': 'O valor mínimo é {min} USDT.',
    'panel.errRestante': 'Restam apenas {monto} USDT disponíveis neste projeto.',
    'panel.errSaldo': 'Você não tem saldo suficiente na sua carteira. Faça um depósito para continuar.',
    'panel.exitoDef': 'Operação realizada.',
    'panel.errorDef': 'Não foi possível concluir a operação. Tente novamente.',
    'inv.ref': 'Investimento #{id}',
    'inv.vendida': 'Vendido',
    'inv.enVenta': 'À venda',
    'inv.invertidos': 'investidos',
    'inv.venceHoy': 'Vence hoje',
    'inv.paraCierre1': '1 dia para o encerramento',
    'inv.paraCierre': '{n} dias para o encerramento',
    'inv.tasa': 'Taxa',
    'inv.vendidaPor': 'Vendido por',
    'inv.saldoTotal': 'Saldo total',
    'inv.fechaVenta': 'Data da venda',
    'inv.cierre': 'Encerramento',
    'inv.yaEnVenta': 'Já está à venda',
    'inv.ponerVenta': 'Colocar à venda',
    'inv.titulo': 'Meus investimentos',
    'inv.sub': 'O que você colocou para render e quanto está ganhando.',
    'inv.kpiInvertido': 'Investido',
    'inv.kpiRend': 'Rendimento acumulado',
    'inv.kpiSaldo': 'Saldo total',
    'inv.kpiActivas': 'Investimentos ativos',
    'inv.tabActivas': 'Ativos',
    'inv.tabVendidas': 'Vendidos',
    'inv.verProyectos': 'Ver projetos',
    'inv.vacioActivas': 'Você ainda não tem investimentos ativos',
    'inv.vacioVendidas': 'Você ainda não vendeu investimentos',
    'inv.vacioActivasAyuda': 'Escolha um projeto e comece a partir de USDT 50.',
    'inv.vacioVendidasAyuda': 'Quando você vender um investimento no mercado secundário, ele aparecerá aqui.',
    'inv.explorar': 'Explorar projetos',
    'inv.fHoy': 'Hoje',
    'inv.fElegir': 'Escolher data',
    'inv.fSin': 'Sem vencimento',
    'inv.modalAria': 'Colocar investimento à venda',
    'inv.rendimiento': 'Rendimento',
    'inv.invertisteEl': 'Você investiu em',
    'inv.cierraEl': 'Encerra em',
    'inv.queParte': 'Que parte você quer vender?',
    'inv.hastaCuando': 'Até quando ficará à venda?',
    'inv.vigencia': 'Validade da oferta',
    'inv.fechaLimite': 'Data limite',
    'inv.recibiras': 'Você receberá quando for vendido',
    'inv.cancelar': 'Cancelar',
    'inv.publicando': 'Publicando…',
    'inv.publicar': 'Publicar oferta',
    'ofertas.confirmarCancelar': 'Cancelar a oferta de {name}? Ela voltará aos seus investimentos ativos.',
    'ofertas.canceladaDef': 'Oferta cancelada.',
    'ofertas.errorCancelar': 'Não foi possível cancelar a oferta.',
    'ofertas.titulo': 'Minhas ofertas',
    'ofertas.sub': 'Investimentos que você colocou à venda no mercado secundário.',
    'ofertas.kpiPublicadas': 'Ofertas publicadas',
    'ofertas.kpiValor': 'Valor à venda',
    'ofertas.tabOfertas': 'Minhas ofertas',
    'ofertas.tabProyectos': 'Meus projetos',
    'ofertas.vacio': 'Você não tem ofertas publicadas',
    'ofertas.vacioAyuda': 'Em Meus investimentos você pode colocar à venda a parte que quiser.',
    'ofertas.irInversiones': 'Ir para meus investimentos',
    'ofertas.ref': 'Oferta #{id}',
    'ofertas.enVenta': 'À venda',
    'ofertas.precioVenta': 'preço de venda',
    'ofertas.montoOfertado': 'Valor ofertado',
    'ofertas.rendimiento': 'Rendimento',
    'ofertas.saldo': 'Saldo',
    'ofertas.publicada': 'Publicada',
    'ofertas.vence': 'Vence',
    'ofertas.cancelando': 'Cancelando…',
    'ofertas.cancelar': 'Cancelar oferta',
    'ofertas.listado': 'Lista de ofertas',
    'ofertas.filtroProyecto': ' - - -  Nome do projeto - - - ',
    'ofertas.filtroVenc': ' - - - Período de vencimento - - -',
    'ofertas.v1': 'Hoje',
    'ofertas.v2': ' Próximos 7 dias',
    'ofertas.v3': ' Próximos 30 dias',
    'ofertas.v4': 'Próximos 360 dias',
    'ofertas.sinProyectosTitulo': 'Ops, nenhum projeto ofertado!',
    'ofertas.sinProyectosD': 'Você ainda não tem projetos próprios ofertados na Panther7',
    'ofertas.sinProyectosM': 'Você ainda não tem projetos próprios ofertados na Panther7',
    'ofertas.suenosD': 'Você sabia que seus sonhos podem se realizar ofertando seus próprios projetos na Panther7? ',
    'ofertas.suenosM': 'Você sabia que seus sonhos podem se realizar ofertando seus próprios projetos na Panther7? ',
    'ofertas.oficinasD': 'Para colocar projetos próprios na Panther7, dirija-se diretamente aos escritórios de consultoria sede na sua região do país ',
    'ofertas.oficinasM': 'Para colocar projetos próprios na Panther7, dirija-se diretamente aos escritórios de consultoria sede na sua região do país! ',
    'ofertas.aceptar': 'OK',
    'srv:Inversión efectuada correctamente': 'Investimento efetuado com sucesso',
    'srv:Compra Efectuada correctamente': 'Compra efetuada com sucesso',
    'srv:Oferta Efectuada correctamente': 'Oferta efetuada com sucesso',
    'srv:Oferta Cancelada correctamente': 'Oferta cancelada com sucesso',
    'srv:Cliente no posee saldo suficiente.': 'Saldo insuficiente.',
    'srv:CLIENTE NO POSEE SALDO SUFICIENTE': 'SALDO INSUFICIENTE',
    'srv: Cantidad excede el disponible para el proyecto': ' Quantidade excede o disponível para o projeto',
    'srv:Cantidad excede el disponible para el proyecto': 'Quantidade excede o disponível para o projeto',
    'srv:Oferta no disponible para la venta': 'Oferta não disponível para venda',
    'srv:La inversion no esta disponible para la venta': 'O investimento não está disponível para venda',
    'srv:Participación no puede ser vendida. No pertenece al cliente o no esta activa': 'A participação não pode ser vendida. Não pertence ao cliente ou não está ativa',
    'srv:Oferta no activa o no pertenece al cliente': 'Oferta não ativa ou não pertence ao cliente',
    'srv:Error al procesar la venta': 'Erro ao processar a venda',
  },
};
